export default {
  meta: {
    title: '租户菜单管理'
  }
};
